import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

export const forcePasswordChangeGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    router.navigate(['/authentication/sign-in']);
    return false;
  }
  if (!authService.authState().userData?.passwordChangeRequired) {
    router.navigate(['/app']);
    return false;
  }
  return true;
};
